<template>
    <div class="o-wrapper">
        <div class="o-grid" :class="cards.length === 0 ? 'o-grid--center' : ''">
            <div v-if="cards.length !== 0 || showPlaceholders" class="o-grid__item u-width-full">
                <div class="cards__wrapper">
                    <div class="cards" id="cards">
                        <content-placeholders v-if="showPlaceholders"></content-placeholders>
                        <post-card-api
                            v-for="card in cards"
                            :key="card.id"
                            :card="card"
                        ></post-card-api>
                        <!-- TODO: BE - I have added front-end lazy loader code in for these
                        but I don't know how you will load it in backend. See js code in _lazyload.js
                        Maybe Vue Lazy Load would be better for this? https://github.com/hilongjw/vue-lazyload -->
                    </div>
                </div>
            </div>
            <div v-else class="o-grid__item u-width-8/12 u-width-full@l" v-if="showEmptyMessage">
                <div class="c-empty-state">
                    <h4>Creating quality {{$root.community.title}} content takes time</h4>
                    <p>{{noContentMessage}}</p>
                    <a href="/post/create" class="c-article__add relative"></a>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import PostCardApi from "../PostCardApi";
import MasonryStore from "../../configs/masonry-store";
import ContentPlaceholders from "../ContentPlaceholders.vue";

export default {
    components: {
        ContentPlaceholders,
        PostCardApi
    },
    data() {
        return {
            cards: [],
            loading: false,
            masonry: MasonryStore,
            next: true,
            page: 1,
            showEmptyMessage: false,
            noContentMessage: 'Your draft section allows you to save your work in progress until you are ready to share it with your communities.',
            showPlaceholders: false
        }
    },
    created() {
        this.$root.$on('profile-search-drafts', (data) => {
            this.fetchData(data);
        });
        this.$root.$on('bus-profile-delete-draft', (postId) => {
            this.removeDraft(postId);
        });
        this.fetchData();
        if (this.$root.community) {
            this.noContentMessage = 'Your draft section allows you to save your work in progress until you are ready to share it with the ' + this.$root.community.title + ' community.';
        }
    },
    updated() {
        this.$nextTick(() => {
            this.masonry.load();
        })
    },
    mounted() {
        window.addEventListener('scroll', this.loadDraftsOnScroll);
    },
    beforeDestroy() {
        window.removeEventListener('scroll', this.loadDraftsOnScroll);
    },
    methods: {
        fetchData(search) {
            if (this.$root.isOwnAccount === false) {
                return;
            }
            const cacheKey = this.$simpleStore.localStorageCacheKeys.drafts;
            const cachedDrafts = this.$simpleStore.getWithSlidingExpiry(cacheKey);
            if (cachedDrafts != null) {
                this.cards = cachedDrafts;
                this.masonry.load();
                return;
            }
            let postData = {
                draft: 1,
                page: this.page,
                user_id: this.$root.profile.user_id,
                community_url: this.$root.community.url,
                search: search
            };
            this.showPlaceholders = this.page === 1;
            this.loading = true;
            this.$http.post('/api/v1/posts/user', postData).then(response => {
                this.loading = false;
                let totalPages = response.data.total_pages;
                if (this.cards.length === 0) {
                    this.cards = response.data.cards;
                } else {
                    this.cards.push.apply(this.cards, response.data.cards);
                }
                this.showPlaceholders = false;
                this.$simpleStore.setWithExpiry(cacheKey, this.cards);
                this.next = totalPages > this.page;
                this.page++;
                if (this.page > totalPages) {
                    window.removeEventListener('scroll', this.loadDraftsOnScroll);
                }
            }, response => {
                if (response.status === 403) {
                    this.$root.$emit('show-private-message');
                }
            });
        },
        loadDraftsOnScroll() {
            if (this.loading === false && this.next) {
                let percentageScroll = (Math.max(window.scrollY, document.documentElement.scrollTop, document.body.scrollTop) + window.innerHeight) / document.documentElement.offsetHeight;
                // load more posts when scrolled 90% of screen height
                if (percentageScroll > 0.9) {
                    this.fetchData();
                }
            }
        },
        removeDraft(postId) {
            const cacheKey = this.$simpleStore.localStorageCacheKeys.drafts;
            let cachedDrafts = this.$simpleStore.getWithSlidingExpiry(cacheKey);
            if (cachedDrafts != null) {
                cachedDrafts = cachedDrafts.filter(post => post.post_id !== postId);
                localStorage.removeItem(cacheKey);
                this.$simpleStore.setWithExpiry(cacheKey, cachedDrafts);
                this.cards = cachedDrafts;
                this.masonry.load();
            }
        }
    }
}
</script>
